import { schema, string } from "@anna-money/anna-web-lib/serializer";

export class ScaSignupData extends schema(
  {
    firstName: string(),
    middleName: string(),
    lastName: string(),
    email: string(),
    dateOfBirth: string(),
    country: string(),
    postcode: string(),
    state: string(),
    suburb: string(),
    streetType: string(),
    streetName: string(),
    streetNumber: string(),
    unit: string(),
  },
  "ScaSignupData",
) {}
